




















































































































































































































































import { snakeCase } from 'lodash'
import moment from 'moment'
import isMobile from 'piramis-js-utils/lib/isMobile'
import { Component, Mixins, Prop, Watch } from 'vue-property-decorator'

import ModelSetter from '../../../../Mixins/ModelSetter'
import WindowResizeMixin from '../../../../logic/helpers/WindowResizeMixin'
import ConfigField from '../../../ConfigField/ConfigField.vue'
import { UseFields } from '../../../Pi'
import FieldWrapper from '../../../Pi/components/FieldWrapper.vue'
import { SelectOptionData } from '../../../Pi/types'
import UserSendMessage from '../UserSendMessage/UserSendMessage.vue'
import UserInfo from './UserInfo.vue'
import BotUsersCore from './index'

enum UserState {
  Active = 'Active',
  Disabled = 'Disabled',
}

@Component({
  data() {
    return {
      moment,
      UserState,
      snakeCase,
      isMobile,
    }
  },
  components: {
    UserSendMessage,
    FieldWrapper,
    ConfigField,
    UserInfo,
  }
})
export default class UsersList extends Mixins<ModelSetter, UseFields, WindowResizeMixin>(ModelSetter, UseFields, WindowResizeMixin) {
  @Prop() core!: BotUsersCore

  get filter(): string {
    return this.core.filter
  }

  set filter(value: string) {
    this.core.page = 1
    this.core.filter = value
  }

  get searchResult(): Array<SelectOptionData> {
    return this.searchText.trim() ? this.core.labelsList.filter((l) => l.label.includes(this.searchText)) : this.core.labelsList
  }

  searchText = ''

  @Watch('core.labels')
  onLabelsChange(labels: Array<number>) {
    this.updateSearchParams({ labels: labels.join(',') })
  }

  inputChange(val: Event) {
    this.updateSearchParams({ search: (val.target as HTMLInputElement).value })
  }

  updateSearchParams(query: Record<string, string>) {
    const location = {
      query: {
        ...this.$route.query,
        ...query
      }
    }

    if (this.$route.fullPath !== this.$router.resolve(location).href) {
      this.$router.replace(location)
    }
  }

  search(text: string): void {
    this.searchText = text
  }

  getLabels(labels: Array<number>): any {
    return labels.map((id) => this.core.getLabel(id))
  }

  pageSizeChanger(changes: { current: number, pageSize: number }): void {
    this.core.pageSizeChanger(changes)

    this.updateSearchParams({ page: changes.current.toString(), pageSize: changes.pageSize.toString() })
  }

  checkQueries() {
    const labels = this.$route.query?.labels?.toString() ?? ''
    const search = this.$route.query?.search?.toString() ?? ''
    const page = +this.$route.query?.page?.toString() || this.core.page
    const pageSize = +this.$route.query?.pageSize?.toString() || this.core.pageSize

    if (labels.trim()) {
      this.core.labels = labels.split(',').map(l => +l)
    }

    if (search.trim()) {
      this.filter = search
    }

    this.pageSizeChanger({ pageSize, current: page })

    return [ labels, search, page, pageSize ]
  }

  created(): void {
    const queries = this.checkQueries()

    if (!queries.some(q => q)) {
      this.core.init()
    }
  }
}
